
			const isMaintenancePageActive = "false" === "true"

			if (isMaintenancePageActive) {
				window.location.pathname = '/maintenance.html'
			} else {
				import("./src/index.tsx")
			}
		